import { TrailerMedia } from '@/services/cms'
import { Asset } from '@/types/asset'
import { Media } from '@/types/store'

const createAsset = ({
  image,
  video,
  file,
}: {
  image?: string
  video?: {
    vod_id?: string
    url?: string
    cover_image?: string
    file_id?: string
  }
  file?: File | null
}): Asset => ({
  ...(image && { image: { url: image } }),
  ...(video && {
    video: {
      url: video.url ?? '',
      vodId: video.vod_id ?? '',
      coverImage: video.cover_image ?? '',
      fileId: video.file_id ?? '',
      isConverted: false,
      isFetching: false,
    },
  }),
  ...(typeof file !== 'undefined' && {
    upload: {
      file: file,
      uploading: false,
      progress: 0,
    },
  }),
})

export const createDefaultAssets = (medias: Media[] = [], withUpload: boolean) => {
  return medias.map((media) =>
    createAsset({
      ...(media.image && { image: media.image.url }),
      ...(media.video && { video: media.video }),
      ...(withUpload && { file: null }),
    }),
  )
}

export const createDefaultTrailerAssets = (medias: TrailerMedia, withUpload: boolean) => {
  const assets: Asset[] = []
  if (!medias) return assets
  if (medias.trailer_videos) {
    medias.trailer_videos.forEach((video) => {
      assets.push(
        createAsset({
          video: {
            vod_id: video.vod_id,
            file_id: video.file_id,
            cover_image: video.cover_image,
          },
          ...(withUpload && { file: null }),
        }),
      )
    })
  }
  if (medias.trailer_images) {
    medias.trailer_images.forEach((image) => {
      assets.push(
        createAsset({
          image: image.url,
          ...(withUpload && { file: null }),
        }),
      )
    })
  }

  return assets
}

export const extractIdFromImageUrl = (imageUrl: string | undefined): string => {
  if (!imageUrl) return ''
  const match = imageUrl.match(/\/assets\/([^\/]+)$/)
  return match ? match[1] : ''
}

export const generateFilePreview = (file: File) => {
  const url = URL.createObjectURL(file)
  return file.type.startsWith('image/')
    ? createAsset({ image: url, video: { url: '' }, file })
    : createAsset({ image: '', video: { url }, file })
}
